import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL"
import "../../assets/css/inventorymanagement.css"

const UserActions = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  
    const columnWithDefs = [
        {
            headerName: "User Code",
            field: "user_code",
            tooltipField: "user_code",
            sortable: true,
            resizable: true,
        },
      {
        headerName: "User Email",
        field: "email",
        tooltipField: "email",
        sortable: true,
        resizable: true,
        width: "300px"
      },
      {
        headerName: "Screen Path",
        field: "path",
        tooltipField: "path",
        sortable: true,
        resizable: true,
        width: "250px"
      },
      {
        headerName: "User Action",
        field: "action",
        tooltipField: "action",
        sortable: true,
        resizable: true,
        width: "400px"
      },
      {
        headerName: "Action Status",
        field: "status",
        tooltipField: "status",
        sortable: true,
        resizable: true,
        width: "160px"
      },
      {
        headerName: "Action Time",
        field: "inserted_date",
        tooltipField: "inserted_date",
        sortable: true,
        width: "200px",
        resizable: true,
        valueGetter: (params) => {
            if (!params.data.inserted_date) return "";
            const date = new Date(params.data.inserted_date);
        
            // Format in UTC
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, "0");
            const day = String(date.getUTCDate()).padStart(2, "0");
            const hours = String(date.getUTCHours()).padStart(2, "0");
            const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        
            return `${year}-${month}-${day} ${hours}:${minutes}`;
          }
      },
        {
        headerName: "Action Date",
        field: "inserted_date",
        tooltipField: "inserted_date",
        sortable: true,
        width: "200px",
        resizable: true,
        valueGetter: (params) => {
            if (!params.data.inserted_date) return "";
            const date = new Date(params.data.inserted_date);
        
            // Format in UTC
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, "0");
            const day = String(date.getUTCDate()).padStart(2, "0");
          
        
            return `${year}-${month}-${day}`;
          }
      }
    ];

  
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    // setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    // resetFormData()
    // setUploadedFileData([]);
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }
  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getUserActionsData = async () => {
    try{
      const response = await redirectURL.post("masters/getUserActionsData", {email: localStorage.getItem("email")})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No User Actions Found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching User Actions:", error);
      setBasicTitle("Failed to fetch User Actions");
      setBasicType("error");
      setShow(true);
    }
  }

  useEffect(() => {
    const getData = async () => {
      setLoadshow("show-m");  
      setOverlayBlock("show-m");
        await getUserActionsData()
      setLoadshow("show-n");  
      setOverlayBlock("show-n");
      }
    getData()

  }, []);

const closeAlert = () => {
  const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }
//   setUploadedFileData([]);
//   setFile(null)
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
//   setSliderOpen(false);
//   setShowDeletePopup(false) 
//   if (isLoadTrue) {
//     window.location.reload()
//   }
};


  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>User Actions</h1>
          </div>
          <div style={addButtonContainerStyle} className="col-sm-12 text-right pr-0 mb-4">
            </div>
            <div className="col-sm-12 p-0 pl-2 mt-6">
              <div className="ag-theme-alpine" style={{ height: 550, width: "100%" }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={100}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
        <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        ></div>
    </>
  );
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };


export default UserActions;